<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <h2>
      Dodajte nov tip plačila:
    </h2>

    <PaymentTypeForm
      @save="save"
      @cancel="cancel"
      :taxLevels="taxLevels"
      :taxTypes="taxTypes"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { saveItem } from '@/utils/crudFunctions'
import PaymentTypeForm from '@/components/PaymentTypeForm'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import { objectToArray } from '@/utils/object'

export default {
  components: {
    PaymentTypeForm
  },
  mixins: [
    asyncDataStatus
  ],
  computed: {
    taxLevels () {
      return objectToArray(this.$store.state.taxLevels.items)
    },
    taxTypes () {
      return objectToArray(this.$store.state.taxTypes.items)
    }
  },
  methods: {
    ...mapActions('paymentTypes', ['saveItem']),
    ...mapActions('taxLevels', { loadTaxLevels: 'loadItems' }),
    ...mapActions('taxTypes', { loadTaxTypes: 'loadItems' }),
    save ({ data }) {
      saveItem(data, 'MyCompanyPaymentTypes', this)
    },
    cancel () {
      this.$router.push({ name: 'MyCompanyPaymentTypes' })
    }
  },
  created () {
    Promise.all([
      this.loadTaxLevels(),
      this.loadTaxTypes()
    ])
      .then(items => { this.asyncDataStatus_fetched() })
  }
}
</script>
